export const environment = {
  production: true,
  localStorageKey: {
    appSettings: 'app-settings',
  },
  emailjs: {
    publicKey: 'aVkp6fodd1FESBQls',
    serviceId: 'service_2c686xq',
    templateId: 'template_5wl2iaf',
  }
};
